import { getCookie } from "@/mixins/cookies";

function getLocale() {
  let locale = getCookie("locale");
  if (locale === "") {
    locale = "en";
  }
  return locale;
}

export { getLocale };
